import { Accordion } from '@/global/components/Accordion'
import { ClassName } from '@/global/types'
import { WButton, WParagraph, WTitle } from '@alice-health/wonderland-react'
import { PropsWithChildren } from 'react'

export interface SimulatorQuestionTemplateProps {
  className?: ClassName
  title: string
  accordionDescription?: string
  loading?: boolean
  disabled?: boolean
  buttonLabel?: string
  backButton?: boolean
  onClick?: (buttonLabel: string) => void
  onBack?: () => void
}

export const SimulatorQuestionTemplate = ({
  className,
  title,
  accordionDescription,
  loading,
  disabled,
  buttonLabel,
  backButton,
  onClick,
  onBack,
  children
}: PropsWithChildren<SimulatorQuestionTemplateProps>) => {
  return (
    <div
      className={`${className} py-gl-spacing-06 px-gl-spacing-08 flex flex-col h-full md:justify-between`}
    >
      <div>
        <div className='flex flex-col gap-3 justify-between'>
          <WTitle
            size='small'
            variant='heavy'
            level='2'
          >
            {title}
          </WTitle>

          {accordionDescription ? (
            <Accordion
              title='Por que essa pergunta?'
              border={false}
              bleeded={true}
            >
              <WParagraph
                className='text-sys-color-content-secondary'
                size='medium'
              >
                {accordionDescription}
              </WParagraph>
            </Accordion>
          ) : null}
        </div>

        {children}
      </div>

      <footer
        className={`flex mt-3 mb-12 md:mb-0 ${
          backButton ? 'justify-between' : 'justify-start md:justify-end'
        }`}
      >
        {backButton ? (
          <WButton
            variant='secondary'
            icon='icArrowLeft'
            iconButton
            onClick={onBack}
            loading={loading}
          />
        ) : null}

        {buttonLabel ? (
          <WButton
            variant='cta'
            icon='icArrowRight'
            iconPosition='trailing'
            loading={loading}
            disabled={disabled}
            onClick={() => onClick?.(buttonLabel)}
          >
            {buttonLabel}
          </WButton>
        ) : null}
      </footer>
    </div>
  )
}
